import {useCookies} from "react-cookie";
import * as config from "../config";

const useAccessToken = () => {
    const [cookies] = useCookies();
    return cookies[config.USER_TOKEN_COOKIE_NAME] ?? '';
};

export default useAccessToken;
